// extracted by mini-css-extract-plugin
export default {"header":"gq","fullPage":"hq","closed":"iq","minimize":"jq","redcircle":"kq","container":"lq","text":"mq","centered":"nq","escapex":"oq"};
    if(module.hot) {
      // 1714422952783
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  